/**
 * @fileoverview
 * Utility functions to prevent API response caching
 */

/**
 * Headers that prevent caching of API responses
 */
export const NO_CACHE_HEADERS = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  Pragma: 'no-cache',
  Expires: '0',
} as const

/**
 * Generates a random string to be used as a cache-busting parameter
 */
const generateCacheBuster = (): string => {
  return Date.now().toString()
}

/**
 * Adds cache prevention headers and a cache-busting parameter to the request config
 * @param url The original URL
 * @param config Optional existing request config
 * @returns Array containing [modifiedUrl, config] with cache prevention
 */
export const preventCache = (
  url: string,
  config: Record<string, unknown> = {},
): [string, Record<string, unknown>] => {
  const separator = url.includes('?') ? '&' : '?'
  const cacheBuster = generateCacheBuster()
  const modifiedUrl = `${url}${separator}_=${cacheBuster}`

  return [
    modifiedUrl,
    {
      ...config,
      headers: {
        ...(config.headers || {}),
        ...NO_CACHE_HEADERS,
      },
    },
  ]
}
